"use strict";

import _objectSpread from "C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import MyAlgo from '@randlabs/myalgo-connect';
import algosdk from 'algosdk';

var Pipeline = /*#__PURE__*/function () {
  function Pipeline() {
    _classCallCheck(this, Pipeline);
  }

  _createClass(Pipeline, null, [{
    key: "init",
    value: function init() {
      return new MyAlgo();
    }
  }, {
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(wallet) {
        var accounts, item1;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return wallet.connect();

              case 3:
                accounts = _context.sent;
                item1 = accounts[0];
                item1 = item1["address"];
                return _context.abrupt("return", item1);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      function connect(_x) {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(address) {
        var amt,
            note,
            sendingAddress,
            wallet,
            algodToken,
            algodServer,
            algodPort,
            data,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                amt = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 1;
                note = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : "Transaction note";
                sendingAddress = _args3.length > 3 ? _args3[3] : undefined;
                wallet = _args3.length > 4 ? _args3[4] : undefined;
                algodToken = {
                  'X-API-Key': 'dmONugeHOX2DC8nDb3v8m6Bo9cI3WHbW6Ntt4QCZ'
                };
                algodServer = "https://mainnet-algorand.api.purestake.io/ps2";
                algodPort = "";
                _context3.next = 9;
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  var algodClient, params, _txn, signedTxn;

                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.prev = 0;
                          algodClient = new algosdk.Algodv2(algodToken, algodServer, '');
                          _context2.next = 4;
                          return algodClient.getTransactionParams().do();

                        case 4:
                          params = _context2.sent;
                          _txn = _objectSpread(_objectSpread({}, params), {}, {
                            type: 'pay',
                            from: sendingAddress,
                            to: address,
                            amount: amt,
                            note: new Uint8Array(Buffer.from(note))
                          });
                          _context2.next = 8;
                          return wallet.signTransaction(_txn);

                        case 8:
                          signedTxn = _context2.sent;
                          _context2.next = 11;
                          return algodClient.sendRawTransaction(signedTxn.blob).do();

                        case 11:
                          return _context2.abrupt("return", signedTxn.txID);

                        case 14:
                          _context2.prev = 14;
                          _context2.t0 = _context2["catch"](0);
                          console.error(_context2.t0);

                        case 17:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[0, 14]]);
                }))();

              case 9:
                data = _context3.sent;
                return _context3.abrupt("return", JSON.stringify(data));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function send(_x2) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "sendASA",
    value: function () {
      var _sendASA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(address) {
        var amt,
            note,
            sendingAddress,
            wallet,
            asaNumb,
            algodToken,
            algodServer,
            algodPort,
            data,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                amt = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : 1;
                note = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : "Transaction note";
                sendingAddress = _args5.length > 3 ? _args5[3] : undefined;
                wallet = _args5.length > 4 ? _args5[4] : undefined;
                asaNumb = _args5.length > 5 ? _args5[5] : undefined;
                algodToken = {
                  'X-API-Key': 'dmONugeHOX2DC8nDb3v8m6Bo9cI3WHbW6Ntt4QCZ'
                };
                algodServer = "https://mainnet-algorand.api.purestake.io/ps2";
                algodPort = "";
                _context5.next = 10;
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                  var algodClient, params, _txn2, signedTxn;

                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.prev = 0;
                          algodClient = new algosdk.Algodv2(algodToken, algodServer, '');
                          _context4.next = 4;
                          return algodClient.getTransactionParams().do();

                        case 4:
                          params = _context4.sent;
                          _txn2 = _objectSpread(_objectSpread({}, params), {}, {
                            type: 'axfer',
                            assetIndex: asaNumb,
                            from: sendingAddress,
                            to: address,
                            amount: amt,
                            note: new Uint8Array(Buffer.from(note))
                          });
                          _context4.next = 8;
                          return wallet.signTransaction(_txn2);

                        case 8:
                          signedTxn = _context4.sent;
                          _context4.next = 11;
                          return algodClient.sendRawTransaction(signedTxn.blob).do();

                        case 11:
                          return _context4.abrupt("return", signedTxn.txID);

                        case 14:
                          _context4.prev = 14;
                          _context4.t0 = _context4["catch"](0);
                          console.error(_context4.t0);

                        case 17:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4, null, [[0, 14]]);
                }))();

              case 10:
                data = _context5.sent;
                return _context5.abrupt("return", JSON.stringify(data));

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function sendASA(_x3) {
        return _sendASA.apply(this, arguments);
      }

      return sendASA;
    }()
  }, {
    key: "createASA",
    value: function () {
      var _createASA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var asName,
            asUnit,
            asURL,
            sendingAddress,
            wallet,
            algodToken,
            algodServer,
            algodPort,
            data,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                asName = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : "";
                asUnit = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : "";
                asURL = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : 'developer.algorand.org';
                sendingAddress = _args7.length > 3 ? _args7[3] : undefined;
                wallet = _args7.length > 4 ? _args7[4] : undefined;
                algodToken = {
                  'X-API-Key': 'dmONugeHOX2DC8nDb3v8m6Bo9cI3WHbW6Ntt4QCZ'
                };
                algodServer = "https://mainnet-algorand.api.purestake.io/ps2";
                algodPort = "";
                _context7.next = 10;
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                  var algodClient, params, signedTxn;
                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.prev = 0;
                          algodClient = new algosdk.Algodv2(algodToken, algodServer, '');
                          _context6.next = 4;
                          return algodClient.getTransactionParams().do();

                        case 4:
                          params = _context6.sent;
                          txn = _objectSpread(_objectSpread({}, params), {}, {
                            fee: 1000,
                            flatFee: true,
                            type: 'acfg',
                            from: sendingAddress,
                            assetName: asName,
                            assetUnitName: asUnit,
                            assetDecimals: 2,
                            assetTotal: 50000000,
                            assetURL: asURL,
                            assetFreeze: '...',
                            assetManager: '...',
                            assetReserve: '...',
                            assetDefaultFrozen: false
                          });
                          _context6.next = 8;
                          return wallet.signTransaction(txn);

                        case 8:
                          signedTxn = _context6.sent;
                          _context6.next = 11;
                          return algodClient.sendRawTransaction(signedTxn.blob).do();

                        case 11:
                          return _context6.abrupt("return", signedTxn.txID);

                        case 14:
                          _context6.prev = 14;
                          _context6.t0 = _context6["catch"](0);
                          console.error(_context6.t0);

                        case 17:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6, null, [[0, 14]]);
                }))();

              case 10:
                data = _context7.sent;
                return _context7.abrupt("return", JSON.stringify(data));

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function createASA() {
        return _createASA.apply(this, arguments);
      }

      return createASA;
    }()
  }]);

  return Pipeline;
}();
/*

usage

const myAlgoWallet = Pipeline.init();

Pipeline.connect(myAlgoWallet)
    .then(data => {
        console.log(data);
    });

Pipeline.send(address, amount, note, sendingAddress, myAlgowallet)
    .then(data => {
        console.log(data);
    });

*/


export { Pipeline as default };